export const throttle = (func, limit, DateNow = Date.now) => {
  let lastFunc;
  let lastRan;
  return (...args) => {
    if (!lastRan) {
      func.apply(this, args);
      lastRan = DateNow();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (DateNow() - lastRan >= limit) {
          func.apply(this, args);
          lastRan = DateNow();
        }
      }, limit - (DateNow() - lastRan));
    }
  };
};
